/**
 * @file 文章列表資料類別
 * @description 格式化文章列表 API 回傳資料
 */
import { formatDefTimeNew } from 'utils/timeUtils';

/** 分頁資料介面 */
interface MetaData {
  page: number;
  perPage: number;
  totalCount: number;
  totalPages: number;
}

/** API 回傳的文章項目介面 */
interface PostApiItem {
  id?: string;
  title?: string;
  date?: string;
  category?: string;
  tag?: string;
  content?: string;
}

/** API 回傳的文章列表介面 */
interface PostsApiResponse {
  metaData?: MetaData;
  postList?: PostApiItem[];
}

/**
 * 文章項目類別
 */
class Post {
  id: string;
  title: string;
  date: string;
  category: string;
  tag: string;
  content: string;

  constructor(data: PostApiItem) {
    this.id = data?.id ?? crypto.randomUUID();
    this.title = data?.title ?? '未知的標題';
    this.date =
      formatDefTimeNew(data?.date, {
        formatString: 'yyyy/MM/dd'
      }) ?? '';
    this.category = data?.category ?? '';
    this.tag = data?.tag ?? '';
    this.content = data?.content ?? '';
  }
}

/**
 * 文章列表資料類別
 */
class GetPostsClass {
  metaData: MetaData;
  postList: Post[];

  constructor(data: PostsApiResponse) {
    this.metaData = {
      page: data?.metaData?.page ?? 1,
      perPage: data?.metaData?.perPage ?? 10,
      totalCount: data?.metaData?.totalCount ?? 66,
      totalPages: data?.metaData?.totalPages ?? 7
    };
    this.postList = data?.postList?.map(_post => new Post(_post)) ?? [];
  }
}

export { GetPostsClass, Post };
export type { MetaData, PostApiItem, PostsApiResponse };
